// extracted by mini-css-extract-plugin
export var icon = "_4s-1";
export var subtext = "_4s-0";